// extracted by mini-css-extract-plugin
export default {"item":"TableOrder_item__VIdVt","dragHandle":"TableOrder_dragHandle__Tx5Bd"};